import React from 'react'
import { FormattedDate, FormattedTime } from 'react-intl'
import { CellCompProps } from '../Table'

const DateCell = <T extends {}> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  return (
    <div title={val} className={`cell ${col.name}`}>
      <FormattedDate value={val} />
      {' '}
      <FormattedTime value={val} />
    </div>
  )
}

export default DateCell
